module.exports = {
    token: null,
    isLoggedIn: null,
    tokenExpirationTime: 12 * 60 * 60 // 12 hours
}